// extracted by mini-css-extract-plugin
export default {"servicesSection":"Services_servicesSection__mLLph","show":"Services_show__Ni2fH","servicesTitle":"Services_servicesTitle__PUVYu","card":"Services_card__SI6Bc"};